export enum TypeFieldsDLocal {
  PAN = 'pan',
  EXPIRATION = 'expiration',
  CVV = 'cvv',
  NUMBER = 'number',
}
